<div class="pos-relative">
  <div class="keno-grid-container">
    <particle-virtual-grid [sourceKey]="sourceType"
                           [sortEnabled]="true"
                           sortFieldKey="TransactionCode"
                           sortDirection="desc"
                           prefixSortFieldKey="FieldValues."
                           serviceName="DetailedConsolidatedTransactionDynamicItemService"
                           api="DAC6Api"
                           [invalidateSubject]="invalidateSubject">
    </particle-virtual-grid>
  </div>
</div>
